/* eslint-disable no-unused-vars */
export enum EDataLayerEventWealth {
  // Get Started
  BANKHYCHYS_ENROLLMENT_PAGEVIEW = 'bankhychys_enroll_pageview',
  BANKHYCHYS_EMAIL_INTENT = 'bankhychys_enroll_email_intent',
  BANKHYCHYS_TERMS_CONSENT = 'bankhychys_enroll_terms_consent',
  BANKHYCHYS_ENROLLMENT_STARTED = 'bankhychys_enroll_started',

  // Enter Phone
  BANKHYCHYS_PHONE_INTENT = 'bankhychys_enroll_phone_intent',
  BANKHYCHYS_PHONE_SUBMIT = 'bankhychys_enroll_phone_submit',

  // Verify Phone
  BANKHYCHYS_VERIFYPHONE_INTENT = 'bankhychys_enroll_verify_phone_intent',
  BANKHYCHYS_PHONEOTPRESEND_SUBMIT = 'bankhychys_enroll_phone_otp_resend_submit',
  BANKHYCHYS_PHONELINKRESEND_SUBMIT = 'bankhychys_enroll_phone_link_resend_submit',
  BANKHYCHYS_PHONE_VERIFIED = 'user_enroll_phone_verified',
  BANKHYCHYS_PHONEOTP_SUBMIT = 'bankhychys_enroll_phone_otp_submit',

  // Personal Info
  BANKHYCHYS_PERSONALINFO_INTENT = 'bankhychys_enroll_personal_info_intent',
  BANKHYCHYS_PERSONALINFO_SUBMIT = 'bankhychys_enroll_personal_info_submit',
  BANKHYCHYS_FULLNAME_SUBMIT = 'user_enroll_fullname_submit',
  BANKHYCHYS_RISKCHECK_VERIFIED = 'user_enroll_preEmptiveRiskCheck_verified',
  EGM_SUBMISSION_PERSONAL_INFO_ACCEPTED = 'egm_submissionPersonalInfo_accepted',

  // Secure Account (Passkey)
  BANKHYCHYS_PASSKEY_VISITED = 'bankhychys_enroll_passkey_visited',
  BANKHYCHYS_PASSKEY_CREATED = 'user_enroll_passkey_created',
  BANKHYCHYS_BROWSER_CREDENTIAL_CREATION_OPTIONS_START = 'bankhychys_enroll_browser_credential_creation_options_start',
  BANKHYCHYS_BROWSER_CREDENTIAL_OPTIONS_CREATION_ERROR = 'bankhychys_enroll_browser_credential_options_creation_error',
  BANKHYCHYS_BROWSER_CREDENTIAL_OPTIONS_CREATION_SUCCESS = 'bankhychys_enroll_browser_credential_options_creation_success',
  BANKHYCHYS_PASSKEY_CREATE_CLICKED = 'user_enroll_passkey_create_clicked',
  BANKHYCHYS_BROWSER_CREDENTIAL_CREATION_START = 'bankhychys_enroll_browser_credential_creation_start',
  BANKHYCHYS_BROWSER_CREDENTIAL_SUBMIT = 'bankhychys_enroll_browser_credential_submit',
  BANKHYCHYS_BROWSER_CREDENTIAL_SUBMIT_SUCCESS = 'bankhychys_enroll_browser_credential_submit_success',
  BANKHYCHYS_BROWSER_CREDENTIAL_SUBMIT_ERROR = 'bankhychys_enroll_browser_credential_submit_error',
  BANKHYCHYS_UNABLE_TO_CREATE_PASSKEY = 'bankhychys_enroll_unable_to_create_passkey',

  // Home Address
  BANKHYCHYS_ADDRESS_INTENT = 'bankhychys_enroll_address_intent',
  BANKHYCHYS_ADDRESS_SUBMIT = 'bankhychys_enroll_address_submit',
  BANKHYCHYS_ADDRESS_VERIFIED = 'user_enroll_address_verified',

  // Verify Identity
  BANKHYCHYS_IDENTITY_INTENT = 'bankhychys_enroll_identity_intent',
  BANKHYCHYS_IDENTITY_SUBMIT = 'bankhychys_enroll_identity_submit',
  BANKHYCHYS_IDENTITY_VERIFIED = 'user_enroll_identity_verified',

  // Employment
  BANKHYCHYS_EMPLOYMENT_SUBMIT = 'bankhychys_enroll_employment_submit',
  BANKHYCHYS_EMPLOYMENT_VERIFIED = 'user_enroll_employment_verified',

  // Finances
  BANKHYCHYS_FINANCES_INTENT = 'bankhychys_enroll_finances_intent',
  BANKHYCHYS_FINANCES_SUBMIT = 'bankhychys_enroll_finances_submit',
  BANKHYCHYS_FINANCES_VERIFIED = 'user_enroll_finances_verified',

  // Verify Email
  BANKHYCHYS_VERIFYEMAIL_INTENT = 'bankhychys_enroll_verify_email_intent',
  BANKHYCHYS_EMAILOTPRESEND_SUBMIT = 'bankhychys_enroll_email_otp_resend_submit',
  BANKHYCHYS_EMAIL_VERIFIED = 'user_enroll_email_verified',

  // Disclosures
  BANKHYCHYS_WEALTHADVISORS_CONSENT = 'bankhychys_enroll_wealth_advisors_consent',
  BANKHYCHYS_CHECKINGSAVINGS_CONSENT = 'bankhychys_enroll_checking_savings_consent',
  BANKHYCHYS_CREATEACCOUNT_SUBMIT = 'bankhychys_enrollment_create_account_submit',
  USER_DISCLOSURES_STARTED = 'user_disclosures_started',
  MILESTONE_CREATE_ACCOUNT_CLICKED = 'user_createAccount_clicked',
  MILESTONE_DISCLOSURES_CONSENT = 'user_disclosures_consent',
  EGM_SUBMISSION_DISCLOSURES_ACCEPTED = 'egm_submissionDisclosures_accepted',
  MILESTONE_ACCOUNT_CREATED = 'egm_account_created',

  // Setting Up
  BANKHYCHYS_ACCOUNT_CREATED = 'bankhychys_user_enroll_account_created',
  BANKHYCHYS_ACCOUNT_DECLINED = 'bankhychys_user_enroll_account_declined',

  // Doc V
  BANKHYCHYS_DOCV_STARTED = 'bankhychys_enroll_docV_started',

  // Doc V Complete
  BANKHYCHYS_DOCV_SUBMIT = 'bankhychys_enroll_docV_ack_submit',

  // Manual Review
  BANKHYCHYS_MANUALREVIEW_STARTED = 'bankhychys_enroll_manual_review_started',

  // Welcome
  BANKHYCHYS_WELCOME_STARTED = 'bankhychys_enroll_welcome_started',
  BANKHYCHYS_WELCOME_SUBMIT = 'bankhychys_enroll_welcome_submit',
  BANKHYCHYS_WELCOME_CONTINUE_CLICKED = 'user_welcomeContinue_clicked',

  // Funding
  BANKHYCHYS_FUNDING_STARTED = 'bankhychys_enroll_funding_started',
  BANKHYCHYS_FUNDING_INTENT = 'bankhychys_enroll_funding_intent',
  BANKHYCHYS_FUNDING_SUBMIT = 'bankhychys_enroll_funding_submit',
  BANKHYCHYS_FUNDING_SKIP = 'bankhychys_enroll_funding_skip',
  BANKHYCHYS_TRANSFER_ACCEPTED = 'bankhychys_enroll_account_transfer_accepted',
  BANKHYCHYS_TRANSFER_REJECTED = 'bankhychys_enroll_account_transfer_rejected',
  BANKHYCHYS_LINKACCOUNT_INTENT = 'bankhychys_enroll_link_account_intent',
  BANKHYCHYS_LINKINSTANTLY_INTENT = 'bankhychys_enroll_link_instantly_intent',
  BANKHYCHYS_LINKMANUALLY_INTENT = 'bankhychys_enroll_link_manually_intent',
  BANKHYCHYS_LINKMANUALLY_SUBMIT = 'bankhychys_enroll_link_manually_submit',
  BANKHYCHYS_LINKACCOUNT_VERIFIED = 'bankhychys_enroll_link_account_verified',
  BANKHYCHYS_LINKACCOUNT_FAILED = 'bankhychys_enroll_link_account_FAILED',
  BANKHYCHYS_UNLINK_ACCOUNT = 'bankhychys_enroll_unlink_account',
  // plaid linking
  BANKHYCHYS_PLAID_LINK_TOKEN_GENERATE_FAIL = 'bankhychys_plaidLinkTokenGenerate_fail',
  BANKHYCHYS_PLAID_LINK_TOKEN_GENERATE_SUCCESS = 'bankhychys_plaidLinkTokenGenerate_success',
  BANKHYCHYS_PLAID_LINK_SUCCESS = 'bankhychys_plaidLink_onSuccess', // generic plaid onSuccess
  BANKHYCHYS_PLAID_LINK_EXIT = 'bankhychys_plaidLink_onExit', // generic plaid onExit event
  BANKHYCHYS_PLAID_LINK_ON_EXIT_FAIL = 'bankhychys_plaidLinkOnExit_fail', // plaid onExit when with errors
  BANKHYCHYS_PLAID_LINK_EVENT = 'bankhychys_plaidLink_onEvent', // generic plaid onEvent
  BANKHYCHYS_PLAID_LINK_FAIL = 'bankhychys_plaidLink_failure', // when app hands plaid data off to EGM
  BANKHYCHYS_FUND_ACCOUNT_PLAID_LINK_CLICKED = 'bankhychys_fundAccountPlaidLink_clicked',
  BANKHYCHYS_FUND_ACCOUNT_MANUAL_LINK_CLICKED = 'bankhychys_fundAccountManualLink_clicked',
  BANKHYCHYS_FUND_ACCOUNT_MODAL_CLOSED = 'bankhychys_fundAccountModal_closed',
  // Funding Success
  BANKHYCHYS_VIEWACCOUNT_INTENT = 'bankhychys_view_account_intent',
}
